import React from 'react';

function Index({name, type, className='', loading, onClick,style={}}) {

    return (
        <button type={type?type:'button'} onClick={()=>{if(!loading){onClick()}}} style={{...style}} className={`btn btn-primary w-100 ${className}`} x="button">
            {
                loading?
                <div className="spinner m-auto">
                    <div className="bounce1" />
                    <div className="bounce2" />
                    <div className="bounce3" />
                </div>
                :name
            }

        </button>
    );
}

export default Index;
